import { Box, Grid, Link, Typography } from '@mui/material'
import { useEffect } from 'react'
import { logEvent } from '../analyticsService'
import { getUserProfile } from '../services/authService'

export const EarlyAccess: React.FC = () => {
    const getAddress = () => {
        const profile = getUserProfile()
        return profile?.nickname
    }
    useEffect(() => {
        logEvent('EarlyAccess', {
            appName: window.location.host,
            value: `userNotRegistered/${getAddress()}`,
        })
    }, [])
    return (
        <Box
            style={{
                height: '100vh',
                width: '100vw',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${process.env.PUBLIC_URL + '/img/rhiza_bg.jpg'})`,
            }}
        >
            <Grid
                container
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    width: '100vw',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                        width: '32vw',
                        backgroundColor: 'white',
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            margin: '8px',
                            fontWeight: 'bold',
                            fontSize: '30px',
                        }}
                    >
                        User Not Registered
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography color="black" sx={{ fontSize: '12px' }}>
                            Thank you for signing in
                        </Typography>
                        <Typography color="black" sx={{ fontSize: '12px' }}>
                            Rhiza has not yet registered this address:
                        </Typography>
                        <Typography
                            color="black"
                            sx={{ fontSize: '12px' }}
                        >{`(${getAddress()})`}</Typography>
                        <Typography color="black" sx={{ fontSize: '12px' }}>
                            {`You can request access `}
                            <Link href="https://rhiza.health/register.html" underline="none">
                                here.
                            </Link>
                        </Typography>
                        <Typography color="black" sx={{ margin: '8px', fontSize: '12px' }}>
                            If you have questions email info@rhiza.health
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                        width: '32vw',
                        borderBottomLeftRadius: '16px',
                        borderBottomRightRadius: '16px',
                        backgroundColor: '#1975d2',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography color="white" sx={{ margin: '8px', fontSize: '12px' }}>
                        Also if you would like to support Rhiza Health, check out:
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            padding: '5px',
                            flexDirection: 'row',
                            width: '32vw',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography color="white" sx={{ fontSize: '12px' }}>
                            <Link
                                color="white"
                                href="https://bounties.gitcoin.co/grants/5931/rhiza-health"
                                underline="none"
                            >
                                Gitcoin Grants |
                            </Link>
                        </Typography>
                        <Typography color="white" sx={{ fontSize: '12px' }}>
                            <Link
                                color="white"
                                href="https://mirror.xyz/rhiza.eth"
                                underline="none"
                            >
                                Mirror |
                            </Link>
                        </Typography>
                        <Typography color="white" sx={{ fontSize: '12px' }}>
                            <Link
                                color="white"
                                href="https://www.linkedin.com/company/rhiza-health-web3"
                                underline="none"
                            >
                                Linkedin |
                            </Link>
                        </Typography>
                        <Typography color="white" sx={{ fontSize: '12px' }}>
                            <Link
                                color="white"
                                href="https://twitter.com/rhizahealth"
                                underline="none"
                            >
                                Twitter
                            </Link>
                        </Typography>
                    </Box>
                </Box>
                <Box mt={3} sx={{ display: 'flex' }} position="absolute" bottom="30px">
                    <img src="/img/rhiza_logo.png" alt="" height={50} />
                    <Typography
                        color="white"
                        height={50}
                        sx={{
                            marginLeft: '10px',
                            marginRight: '10px',
                            fontWeight: 'bold',
                            fontSize: '30px',
                        }}
                    >
                        Rhiza
                    </Typography>
                    <Typography color="white" height={50} sx={{ fontSize: '30px' }}>
                        Health
                    </Typography>
                    .
                </Box>
            </Grid>
        </Box>
    )
}
